import { LogOut } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface AppHeaderProps {
  userDisplayName?: string
  onLogout: () => void
  showBrand?: boolean
}

export function AppHeader({ userDisplayName, onLogout, showBrand = true }: AppHeaderProps) {
  return (
    <header
      className="flex shrink-0 items-center justify-between gap-2 border-b border-border px-4 py-2 pt-[max(0.5rem,env(safe-area-inset-top))]"
      data-testid="app-header"
    >
      {showBrand ? (
        <div className="min-w-0">
          <p className="truncate text-xs font-medium uppercase tracking-wide text-primary">ModelScout AI Lab</p>
          <h1 className="truncate text-sm font-semibold">Model Laboratory</h1>
        </div>
      ) : (
        <div className="min-w-0 flex-1" />
      )}

      <div className="flex shrink-0 items-center gap-2">
        {userDisplayName ? (
          <span className="hidden max-w-[8rem] truncate text-xs text-muted-foreground sm:inline">
            {userDisplayName}
          </span>
        ) : null}
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="min-h-11 min-w-11 px-2"
          onClick={onLogout}
          data-testid="logout-button"
          aria-label="Logout"
        >
          <LogOut className="h-4 w-4 sm:mr-1" aria-hidden />
          <span className="hidden sm:inline">Logout</span>
        </Button>
      </div>
    </header>
  )
}
